import LoadingComponent from "../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState, useRef  } from "react";
import { useStore } from "../../app/stores/store";
import { useParams } from "react-router";
import "./homeLoggedIn.css"
import { SGPersonaFormValues, SGPersona } from '../../app/models/SGPersona';
import Container from "react-bootstrap/Container";
import Section from "react-bootstrap/Container";
import { Carousel} from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, Icon } from 'semantic-ui-react';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Route, Switch } from "react-router-dom";


import CarouselItem from 'react-bootstrap/CarouselItem';
import CarouselCaption from 'react-bootstrap/CarouselCaption';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import { Image } from 'semantic-ui-react'
import Footer from "../Footer";
import loginPlaceholder from '../../../src/images/docente-placeholder.png';


import ActualizarContraseña from "../../features/SGPersonas/form/ActualizarContraseña/ActualizarContraseña";
import RecibosGenerados from "../../features/profiles/Recibos/RecibosGenerados";
import MisDiplomas from "../../features/profiles/Diplomas/MisDiplomas";
import CATNotas from "../../features/profiles/Notas/MisNotas";
import ProfileDetails from "../../components/pages/ProfileDetails"
import ProfileEdit from "../../components/pages/ProfileEdit"
import ProfileFotos from "../../features/profiles/ProfileFotos";
import CCTCuentas from "../../features/profiles/CCTCuenta/CCTCuenta"




export default observer(function LoggedInUser() {

  const { CATCursosStore, userStore: { user, logout }, modalStore, profileStore } = useStore();
  const { loadCATCursos, getCATCursosRegistryAll } = CATCursosStore;
  const data_cursos = CATCursosStore.getCATCursosByCodigoAll;
  const {loadingProfile, loadProfile, profile} = profileStore;
  const perfilAPI = process.env.REACT_APP_API_URL + `/Courses/MyCourses?Student=${user?.id}`;
  
  const [curso, setCursos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [displayName, setDisplayName] = useState(user?.displayName);
  

  const updateDisplayName = (newName: string) => {
    setDisplayName(newName);
  };
  
  const username: string | undefined = user?.email;
  useEffect(() => {
    loadProfile(username);
    }, [loadProfile, username])

    useEffect(() => {
  
      
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
  
        window.addEventListener('resize', handleResize);
  
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const SaldosPendientes = () => (
      <div>
        <CCTCuentas />
      </div>
    );
    const Diplomas = () => (
      <div>
          <MisDiplomas />
      </div>
    );
    const Recibos = () => (
      <div>
        <RecibosGenerados />
      </div>
    );
    const Notas = () => (
      <div>
        <CATNotas />
      </div>
    );

    const Fotos = () => (
      <div>
        {profile && <ProfileFotos profile={profile} />}
      </div>
    )

    const Editar = () => (
      <div>
        {profile && <ProfileEdit ruta={"/home/profile/editar/:id?"} profile={profile} updateDisplayName={updateDisplayName}/>}
      </div>
    )

  return (

    <>

      <Container className="content-mid-fluid-area">
        <Row>
          {/* -- Barra de seleccion -- */}
          <Col md={3} className="contenedor-sidebar">
            <Section className="sidebar-user-info">
              <div className="photo-container">
                <Image className="shadow-md" src={user?.image || loginPlaceholder} size='medium' circular />
                <Link to={`/home/profile/${user?.userName}/${user?.id}/Fotos`}>
                  <Button className="button-photo" ><Icon name="pencil"/></Button>
                </Link>
              </div>
              <h2>{displayName}</h2>
              <p>{user?.email}</p>
              {user &&
              <Button className="button-password" onClick={() => modalStore.openModal(<ActualizarContraseña userId={user.id}/>, 'mini')}>Cambiar contraseña</Button>}
            </Section>
            <Section className="sidebar-vertical-menu">
              <ul className="sidebar-menu-content">
              <Link to={`/home/profile/${user?.userName}/${user?.id}/Perfil`}>
                  <li>
                    Inicio
                  </li>
                </Link>
                <Link to={`/home/profile/editar/${user?.id}`}>
                  <li>
                    Editar mi perfil
                  </li>
                </Link>

                <Link to={`/home/profile/${user?.userName}/${user?.id}/SaldosPendientes`}>
                  <li>
                    Saldos pendientes
                  </li>
                </Link>

                <Link to={`/home/profile/${user?.userName}/${user?.id}/Recibos`}>
                  <li>
                    Recibos generados
                  </li>
                </Link>

                <Link to={`/home/profile/${user?.userName}/${user?.id}/Notas`}>
                  <li>
                    Notas o calificaciones
                  </li>
                </Link>

                <Link to={`/home/profile/${user?.userName}/${user?.id}/Diplomas`}>
                  <li>
                    Diplomas
                  </li>
                </Link>

                <Link to={"/"} onClick={logout}>
                  <li>
                    Cerrar sesión
                  </li>
                </Link>

              </ul>
            </Section>
          </Col>
          
          {/* --Contenido -- */}
          <Col md={9}>
            {profile && <Switch>
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/Perfil`} component={ProfileDetails}/>
                          <Route exact path="/home/profile/editar/:id?" component={Editar} />
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/SaldosPendientes`} component={SaldosPendientes} />
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/Diplomas`} component={Diplomas} />
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/Recibos`} component={Recibos} />
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/Notas`} component={Notas} />
                          <Route exact path={`/home/profile/${user?.userName}/${user?.id}/Fotos`} component={Fotos} />
                        </Switch>}
            
          </Col>
        </Row>

      </Container>

      <Footer />

      

      {/* <WelcomeModal 
        key={Math.random()}
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        nombre={user?.displayName}
      /> */}

    </>
  )

})